import { useState, useEffect } from "react";

function useDelayedUnmount(isMounted: boolean, delay: number) {
  const [shouldRender, setShouldRender] = useState(isMounted);

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>;

    if (isMounted) {
      // Immediately mount if isMounted is true
      setShouldRender(true);
    } else {
      // Delay unmounting
      timeoutId = setTimeout(() => {
        setShouldRender(false);
      }, delay);
    }

    // Cleanup the timeout if isMounted/delay changes or component unmounts
    return () => clearTimeout(timeoutId);
  }, [isMounted, delay]);

  return shouldRender;
}

export default useDelayedUnmount;
